"use client";

import { useTranslations } from "next-intl";
import { useEffect, useRef } from "react";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { gsap } from "gsap/dist/gsap";

const ReasonCard = (props: { number: string; title: string; desc: string }) => {
  return (
    <div
      className="min-w-[310px] max-w-[310px] xl:min-w-[555px] 
                  xl:max-w-[555px] xl:mr-[320px] mr-[84px]"
    >
      <span
        className=" text-[40px] xl:text-[72px] font-degular-display-semibold
        !leading-[1]"
      >
        {props.number}
      </span>
      <p
        className=" mb-[8px] xl:mb-[24px] mt-[20px] xl:mt-[44px] 
                    text-[32px] xl:text-[56px] font-degular-display-semibold  "
      >
        {props.title}
      </p>
      <p
        className="font-degular-display-medium text-[16px] 
                    xl:!text-[24px] !leading-[1.2]"
      >
        {props.desc}
      </p>
    </div>
  );
};

function WhyTravelThruSection() {
  const t = useTranslations("About");
  const sectionRef = useRef(null);
  const triggerRef = useRef(null);

  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    let mm = gsap.matchMedia();
    mm.add("(min-width: 1280px)", () => {
      gsap.fromTo(
        sectionRef.current,
        {
          translateX: 0,
        },
        {
          
          translateX: // @ts-ignore
            "-" + (triggerRef?.current?.clientWidth) ?? "-100vw",
          ease: "none",
          duration: 1,
          scrollTrigger: {
            trigger: triggerRef.current,
            start: "top top",
            scrub: 0.6,
            pin: true,
          },
        }
      );
    });

    return () => {
      mm.kill();
    };
  }, []);

  return (
    <section className="max-w-screen overflow-hidden">
      <div
        ref={triggerRef}
        className="flex flex-col items-start bg-black w-screen
                     xl:pt-[131px] xl:pb-[189px] pt-[50px] pb-[60px]"
      >
        <div
          className="flex flex-row items-start space-x-[90px] mb-[64px] xl:mb-[120px] 
                    w-full px-[40px] 2xl:px-0 justify-center "
        >
          <div className=" w-full max-w-screen-xl ">
            <p className="h1 text-white">{t("why_travelthru")}</p>
          </div>
        </div>
        <div className="max-xl:w-full max-xl:overflow-x-scroll">
          <div
            ref={sectionRef}
            className=" flex flex-row text-white relative px-[40px] 2xl:px-0
                      overflow-y-hidden  no-scrollbar"
          >
            <div className="2xl:ml-[calc((100vw-1280px)/2)] " />
            <ReasonCard
              number={"01"}
              title={t("unleash_your_wanderlust")}
              desc={t(
                "explore_destinations_like_never_before_with_our_intuitive_trip_planning_tools_dream_plan_and_experience_your_dream_vacation_effortlessly"
              )}
            />
            <ReasonCard
              number={"02"}
              title={t("tailored_experiences")}
              desc={t(
                "personalize_your_itinerary_to_match_your_unique_travel_style_and_preferences_whether_you_crave_cultural_immersion_a_culinary_adventure_or_a_nature_retreat_travelthru_has_you_covered"
              )}
            />
            <ReasonCard
              number={"03"}
              title={t("seamless_collaboration")}
              desc={t(
                "easily_plan_trips_with_friends_and_family_share_ideas_follaborate_on_itineraries_and_create_memories_together"
              )}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyTravelThruSection;
